import cls from 'classnames';

const styles = {
  wrapper: (isInline: boolean) => cls(isInline ? 'text-box' : 'content-box'),
};

export default styles;
